"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAccessKeySinkContext;

var _react = require("react");

var _Context = _interopRequireDefault(require("./Context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useAccessKeySinkContext() {
  return (0, _react.useContext)(_Context.default);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9VdGlscy9BY2Nlc3NLZXlTaW5rL2ludGVybmFsL3VzZUNvbnRleHQuanMiXSwibmFtZXMiOlsidXNlQWNjZXNzS2V5U2lua0NvbnRleHQiLCJBY2Nlc3NLZXlTaW5rQ29udGV4dCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOzs7O0FBRWUsU0FBU0EsdUJBQVQsR0FBbUM7QUFDaEQsU0FBTyx1QkFBV0MsZ0JBQVgsQ0FBUDtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VDb250ZXh0IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgQWNjZXNzS2V5U2lua0NvbnRleHQgZnJvbSAnLi9Db250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlQWNjZXNzS2V5U2lua0NvbnRleHQoKSB7XG4gIHJldHVybiB1c2VDb250ZXh0KEFjY2Vzc0tleVNpbmtDb250ZXh0KTtcbn1cbiJdfQ==